import React from 'react';
import PropTypes from 'prop-types';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import classes from './Loader.module.css';
const { CircularProgress } = MaterialUiCore;

const Loader = ({ show }) =>
    show && (
        <div className={classes.loaderDiv}>
            <CircularProgress color="secondary" size="3rem" className={classes.ajaxLoader} />
        </div>
    );

Loader.propTypes = {
    show: PropTypes.bool.isRequired,
};
export default Loader;
